/**
 * Best-effort "is this a low-end device" check (docs/06-roadmap.md P4-08 performance audit —
 * see AmbientBackground.tsx's own header comment for why this exists: freezing the ambient
 * drift animation is what actually saves cost on a device where `backdrop-filter` is expensive,
 * not weakening the blur/opacity themselves).
 *
 * `navigator.deviceMemory` (Chromium only) is the more direct signal and is checked first;
 * `navigator.hardwareConcurrency` (broader browser support, including Safari/Firefox) is the
 * fallback when memory isn't exposed. Neither is available everywhere, so this can under-detect
 * (never over-detects into freezing motion for a capable device that merely hides one signal).
 */
const LOW_END_MEMORY_GB = 4;
const LOW_END_CORES = 4;

export function prefersReducedAmbientMotion(): boolean {
  if (typeof navigator === 'undefined') return false;
  const memory = (navigator as Navigator & { deviceMemory?: number }).deviceMemory;
  if (typeof memory === 'number') return memory <= LOW_END_MEMORY_GB;
  const cores = navigator.hardwareConcurrency;
  return typeof cores === 'number' && cores <= LOW_END_CORES;
}
